export function adjustForTimezone(date:Date):Date{
    var timeOffsetInMS:number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date
}

/**
 * Converts an ISO date string to local datetime format for HTML datetime-local input
 * @param isoString ISO date string from API
 * @returns Local datetime string in YYYY-MM-DDTHH:mm format
 */
export function toLocalDateTimeString(isoString: string): string {
    if (!isoString) return '';
    
    const date = new Date(isoString);
    
    // Get local date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * Converts a local datetime string from HTML input to ISO string for API
 * @param localDateTimeString Local datetime string in YYYY-MM-DDTHH:mm format
 * @returns ISO date string
 */
export function fromLocalDateTimeString(localDateTimeString: string): string {
    if (!localDateTimeString) return '';
    
    const date = new Date(localDateTimeString);
    return date.toISOString();
}

/**
 * Converts an ISO date string to local date format for HTML date input
 * @param isoString ISO date string from API
 * @returns Local date string in YYYY-MM-DD format
 */
export function toLocalDateString(isoString: string): string {
    if (!isoString) return '';
    
    const date = new Date(isoString);
    
    // Get local date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
}

/**
 * Converts a local date string from HTML input to ISO string for API
 * Sets time to end of day (23:59:59) to ensure the due date covers the entire day
 * @param localDateString Local date string in YYYY-MM-DD format
 * @returns ISO date string with end of day time
 */
export function fromLocalDateString(localDateString: string): string {
    if (!localDateString) return '';
    
    // Create date and set to end of day for due dates
    const date = new Date(localDateString + 'T23:59:59');
    return date.toISOString();
}

/**
 * Determines whether a native date input's onChange value should be dispatched
 * @param rawValue Current event.target.value from the date input
 * @param previousValue Currently stored value for this field, if any
 * @returns true if the change should be committed
 */
export function shouldCommitDateInputChange(rawValue: string, previousValue: string | undefined): boolean {
    // Native date inputs report '' for incomplete segments mid-typing, not just explicit clears
    return rawValue !== '' || !!previousValue;
}